import {Injectable} from "@angular/core";
import {Environment} from "../../enums";

@Injectable({
  providedIn: "root"
})
export class EnvironmentDetectionService {
  /**
   * Detects the current application environment based on the hostname
   * @param testHostname - Optional hostname for testing purposes
   * @returns Environment - The detected environment (INTEGRATION, STAGING, or PRODUCTION)
   */
  public getCurrentAppEnvironment(testHostname?: string): Environment {
    const hostname = testHostname || window.location.hostname;

    // Integration patterns:
    // - cms-d.corp.trumpf.com
    // - cockpit.dev.mytbs.trumpf.com
    // - localhost (for local development)
    if (hostname.includes("cms-d.corp.trumpf.com") || hostname.includes(".dev.mytbs.") || hostname === "localhost" || hostname === "127.0.0.1") {
      return Environment.INTEGRATION;
    }

    // Staging patterns:
    // - trumpf.com.cms.qa.tru
    // - cockpit.qa.mytbs.trumpf.com
    if (hostname.includes(".qa.tru") || hostname.includes(".qa.mytbs.")) {
      return Environment.STAGING;
    }

    // Production patterns:
    // - trumpf.com.cms.tru
    // - cockpit.prod.mytbs.trumpf.com
    // - cockpit.mytbs.trumpf.com (without environment prefix)
    if (
      (hostname.includes(".cms.tru") && !hostname.includes(".dev.") && !hostname.includes(".qa.")) ||
      hostname.includes(".prod.mytbs.") ||
      (hostname.includes(".mytbs.trumpf.com") && !hostname.includes(".dev.") && !hostname.includes(".qa."))
    ) {
      return Environment.PRODUCTION;
    }

    // Fallback to Integration
    return Environment.INTEGRATION;
  }

  /**
   * Get a label for the current environment
   */
  public getCurrentEnvironmentLabel(): string {
    const env = this.getCurrentAppEnvironment();
    switch (env) {
      case Environment.INTEGRATION:
        return "Integration";
      case Environment.STAGING:
        return "Staging";
      case Environment.PRODUCTION:
        return "Production";
      default:
        return "Unknown";
    }
  }
}
